import { FunctionComponent } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import ReactInputMask from 'react-input-mask';

import TextField from '@Components/TextField';
import { ReactHookFormError } from '@Typings/global.types';

import TextFieldWrapperWithInputMaskProps from './TextFieldWrapperWithInputMaskProps.types';

const TextFieldWrapperWithInputMask: FunctionComponent<TextFieldWrapperWithInputMaskProps> =
  (props: TextFieldWrapperWithInputMaskProps): JSX.Element => {
    const {
      label,
      placeholder,
      name,
      onChange,
      initialValue,
      mask,
      ...resProps
    } = props;

    const {
      control,
      formState: { errors },
    } = useFormContext();

    return (
      <Controller
        name={name}
        control={control}
        defaultValue={initialValue}
        render={({ field: { ref, ...resField } }) => (
          <ReactInputMask
            ref={ref}
            mask={mask}
            {...resField}
            onChange={(
              e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
            ) => {
              if (onChange) {
                onChange(e);
              }
              resField.onChange(e);
            }}
          >
            {(inputProps: any) => (
              <TextField
                {...inputProps}
                {...resProps}
                label={label}
                variant="outlined"
                placeholder={placeholder}
                error={!!errors[name]}
                helperText={
                  (errors[name] as unknown as ReactHookFormError)?.message
                }
              />
            )}
          </ReactInputMask>
        )}
      />
    );
  };

TextFieldWrapperWithInputMask.defaultProps = {
  initialValue: '',
};

export default TextFieldWrapperWithInputMask;
